
import { apiConstants } from "../../shared/config";
import work from "./type";
const code = apiConstants.code;
const baseRouteName = `${code}.${work.key}_`;

export const type = work.key;
export const routes = {
    path: `/${code}/${work.basePath}`,
    component: () => import ( /* webpackChunkName: "gimgestao-parish-interventions" */ './views/ParishInterventionsBase.vue'),
    children: [
        {
            path: `home`,
            name: `${code}.${work.basePath}.home`,
            component: () => import ( /* webpackChunkName: "gimgestao-parish-interventions" */ './views/Home.vue'),
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'parish_interventions_home_manage.title',
            }
        },
        {
            path: `statuses`,
            component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-statuses" */ './views/status/StatusBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}statuses`,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-statuses" */ './views/status/StatusList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_statuses.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}statuses.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-statuses" */ './views/status/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_statuses.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}statuses.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-statuses" */ './views/status/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_statuses.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'parish_interventions_statuses.title',
            }
        },
        {
            path: `types`,
            component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-types" */ './views/type/TypeBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}types`,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-types" */ './views/type/TypeList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_types.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}types.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-types" */ './views/type/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_types.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}types.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-types" */ './views/type/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_types.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'parish_interventions_types.title',
            }
        },
        {
            path: `claimants`,
            component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-claimants" */ './views/claimant/ClaimantBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}claimants`,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-claimants" */ './views/claimant/ClaimantList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_claimants.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}claimants.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-claimants" */ './views/claimant/ClaimantDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_claimants.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}claimants.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-claimants" */ './views/claimant/ClaimantDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_claimants.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'parish_interventions_claimants.title',
            }
        },
        {
            path: `unities`,
            component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-unities" */ './views/unity/UnityBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}unities`,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-unities" */ './views/unity/UnityList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_unities.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}unities.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-unities" */ './views/unity/UnityDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_unities.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}unities.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-unities" */ './views/unity/UnityDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_unities.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'parish_interventions_unities.title',
            }
        },
        {
            path: `contract_types`,
            component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-contracttypes" */ './views/contractType/ContractTypeBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}contract_types`,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-contracttypes" */ './views/contractType/ContractTypeList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_contract_types.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}contract_types.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-contracttypes" */ './views/contractType/ContractTypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_contract_types.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}contract_types.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-contracttypes" */ './views/contractType/ContractTypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_contract_types.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'parish_interventions_contract_types.title',
            }
        },
        {
            path: `procedure_types`,
            component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-proceduretypes" */ './views/procedureType/ProcedureTypeBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}procedure_types`,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-proceduretypes" */ './views/procedureType/ProcedureTypeList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_procedure_types.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}procedure_types.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-proceduretypes" */ './views/procedureType/ProcedureTypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_procedure_types.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}procedure_types.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-parish-interventions-proceduretypes" */ './views/procedureType/ProcedureTypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_procedure_types.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'parish_interventions_procedure_types.title',
            }
        },
        {
            path: `global_types`,
            component: () => import( /* webpackChunkName: "gimgestao-types" */ './views/typeGlobal/TypeBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}global_types`,
                    component: () => import( /* webpackChunkName: "gimgestao-types" */ './views/typeGlobal/TypeList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_types.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}global_types.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-types" */ './views/typeGlobal/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_types.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}global_types.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-types" */ './views/typeGlobal/TypeDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_types.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'global_types.titles',
            }
        },
        {
            path: `global_statuses`,
            component: () => import( /* webpackChunkName: "gimgestao-statuses" */ './views/statusGlobal/StatusBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}global_statuses`,
                    component: () => import( /* webpackChunkName: "gimgestao-statuses" */ './views/statusGlobal/StatusList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_statuses.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}global_statuses.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-statuses" */ './views/statusGlobal/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_statuses.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}global_statuses.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-statuses" */ './views/statusGlobal/StatusDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'global_statuses.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'global_statuses.titles',
            }
        },
        {
            path: `reports`,
            component: () => import( /* webpackChunkName: "gimgestao-reports" */ './views/report/ReportBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}reports`,
                    component: () => import( /* webpackChunkName: "gimgestao-reports" */ './views/report/ReportList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_reports.titles',
                    }
                },
                {
                    path: 'config',
                    name: `${baseRouteName}reports.config`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-reports" */ './views/report/ReportConfig.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_reports.title',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}reports.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-reports" */ './views/report/ReportDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_reports.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}reports.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-reports" */ './views/report/ReportDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'parish_interventions_reports.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'parish_interventions_reports.titles',
            }
        },
        {
            path: `notifications`,
            component: () => import( /* webpackChunkName: "gimgestao-notifications" */ './views/notification/NotificationBase.vue'),
            children: [
                {
                    path: '/',
                    name: `${baseRouteName}notifications`,
                    component: () => import( /* webpackChunkName: "gimgestao-notifications" */ './views/notification/NotificationList.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'notifications.titles',
                    }
                },
                {
                    path: 'create',
                    name: `${baseRouteName}notifications.create`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-notifications" */ './views/notification/NotificationDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'notifications.title',
                    }
                },
                {
                    path: ':id',
                    name: `${baseRouteName}notifications.show`,
                    props: true,
                    component: () => import( /* webpackChunkName: "gimgestao-notifications" */ './views/notification/NotificationDetails.vue'),
                    meta: {
                        auth: undefined,
                        hideHeaderName: true,
                        title: 'notifications.title',
                    }
                },
            ],
            meta: {
                auth: undefined,
                hideHeaderName: true,
                title: 'notifications.titles',
            }
        },
    ],
    meta: {
        auth: undefined,
        hideHeaderName: true,
        title: 'parish_interventions_home_manage.title',
    }
};

export default routes;